export default __webpack_public_path__ + "static/media/map1.67cf5bc3.png";